var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head-bar title-bg"},[_c('van-nav-bar',{attrs:{"title":_vm.title,"left-text":"","right-text":"","left-arrow":_vm.isEntry},on:{"click-left":_vm.onClickLeft,"click-right":_vm.onClickRight}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }